export { default as ControlLabel } from './component';
export * from './hook';
